module.exports = __webpack_public_path__ + "img/1.7daf7c1f.png";